import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { client } from "../utils/api";
import Collapse from "./collapse";

function PageList({ children }) {
  const [pages, setPages] = useState([]);
  const [open, setOpen] = useState(false);
  const navigation = useRef(null);
  const trigger = useRef(null);
  const { pathname } = useLocation();
  const activePage = pages.find((page) => pathname === `/page/${page.slug}`);

  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    if (!open) return;
    const onPointerDown = (event) => {
      if (!navigation.current.contains(event.target)) setOpen(false);
    };
    const onKeyDown = (event) => {
      // Let an open hours popover handle Escape before closing its parent.
      if (
        event.key === "Escape" &&
        !navigation.current.querySelector("#opening-hours-popover")
      ) {
        setOpen(false);
        trigger.current.focus();
      }
    };
    document.addEventListener("pointerdown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  useEffect(() => {
    const controller = new AbortController();
    client("store/pages/", { signal: controller.signal })
      .then((response) => {
        if (!controller.signal.aborted) {
          setPages(Array.isArray(response) ? response : []);
        }
      })
      .catch(() => {});
    return () => controller.abort();
  }, []);

  return (
    <nav
      className={`page-navigation${
        pages.length === 0 ? " page-navigation--no-pages" : ""
      }`}
      aria-label="Nawigacja restauracji"
      ref={navigation}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
      }}
    >
      <NavLink
        exact
        to="/"
        className="header-nav-pill"
        activeClassName="header-nav-pill--active"
      >
        Menu
      </NavLink>
      {children}
      {pages.length > 0 && (
        <button
          ref={trigger}
          type="button"
          className={`header-nav-pill mobile-information-trigger${
            activePage ? " header-nav-pill--active" : ""
          }`}
          aria-expanded={open}
          aria-controls="restaurant-information-links"
          onClick={() => setOpen((value) => !value)}
        >
          <span>{activePage ? activePage.title : "Informacje"}</span>
          <ChevronDown size={16} aria-hidden="true" />
        </button>
      )}
      {pages.length > 0 && (
        <Collapse
          mobileOnly
          expanded={open}
          id="restaurant-information-links"
          className="header-information-panel"
        >
          <div className="header-information-links">
            {pages.map((page) => (
              <NavLink
                key={page.pk}
                to={`/page/${page.slug}`}
                className="header-nav-pill"
                activeClassName="header-nav-pill--active"
                onClick={() => setOpen(false)}
              >
                {page.title}
              </NavLink>
            ))}
          </div>
        </Collapse>
      )}
    </nav>
  );
}

export default PageList;
